import $ from 'jquery';
let recaptcha = null;
let documentLoaded = false;

window.recaptchaLoaded = function () {
    recaptcha = window.grecaptcha;
    recaptchaInit('recaptcha');
};

export function recaptchaInit(trigger) {
    if (trigger === 'document') {
        documentLoaded = true;
    }

    if (!recaptcha) return;
    if (!documentLoaded) return;


    $('.js-recaptcha-form').each((index, element) => {
        let verified = false;
        const $form = $(element);
        const recaptchaEl = $form.find('.g-recaptcha')[0];
        const recaptchaId = recaptcha.render(recaptchaEl, { callback: onVerify }, true);

        $form.on('submit', function (evt) {
            if (!verified) {
                evt.preventDefault();
                recaptcha.execute(recaptchaId);
                return;
            }
        });

        function onVerify(token) {
            if (!token) return;

            verified = true;

            $form.append(`<input type="hidden" name="g-recaptcha-response" value="${token}"/>`);
            $form.trigger('submit');
        }
    });
}
